const appKey = process.env.REACT_APP_KEY;
const currentAppVersion = process.env.REACT_APP_VERSION;
const demoMode = process.env.REACT_APP_DEMO_MODE;
const userName = process.env.REACT_APP_USERNAME;
const password = process.env.REACT_APP_PASSWORD;

export default {
    appKey,
    currentAppVersion,
    demoMode,
    userName,
    password,
};
